module.exports = require('./src/ipfs-pubsub');